import { observable, action, runInAction } from 'mobx'
import { ALBUM_KIND } from '@components/Hotel/constant'
import { Modal } from 'hljd'
import Api from '@api/hotel/albumManage'
import VrApi from '@api/hotel/vr'

const confirm = Modal.confirm
export default class {
  @observable albumKind
  @observable sceneList = []
  @observable status = {}
  @observable tab = -1
  @observable activeKey
  @observable vrPrivilege = false

  @action
  setActiveKey = key => {
    this.activeKey = key
  }

  @action
  setTab = tab => {
    this.tab = tab
  }

  @action
  getAlbumStatus = async () => {
    const { data } = await Api.getAlbumStatus()
    if (!data) {
      return
    }
    runInAction(() => {
      this.status = {
        [ALBUM_KIND.MARRY_HOUSE]: data.bridalRoomStatus,
        [ALBUM_KIND.GUEST_HOUSE]: data.guestRoomStatus,
        [ALBUM_KIND.SPECIAL_HOUSE]: data.featuredVenuesStatus,
        [ALBUM_KIND.OUTWARD]: data.appearanceDelStatus,
        [ALBUM_KIND.HALL]: data.lobbyDelStatus,
        [ALBUM_KIND.EFFECT]: data.effectDelStatus
      }
    })
  }

  @action
  getPhotoAlbumScene = async () => {
    const { success, data } = await Api.photoAlbumScene()
    if (success) {
      runInAction(() => {
        this.sceneList = data
        this.tab !== -1 || this.activeKey
          ? (this.albumKind =
              this.activeKey ||
              String(
                this.sceneList
                  .map(item => item.id)
                  .find(item => String(item) === this.tab)
              ))
          : (this.albumKind = String(this.sceneList.map(item => item.id)[0]))
      })
    }
  }

  @action
  getVrPrivilege = async () => {
    const {
      data: { hotelVr }
    } = await VrApi.getMerchantPrivilege()
    runInAction(() => {
      this.vrPrivilege = !!+hotelVr
    })
  }

  @action
  changeTab = key => {
    confirm({
      title: '温馨提示',
      content: '切换分类可能会丢失未保存的内容哦！',
      okText: '切换分类',
      style: { fontSize: 14 },
      onOk: () => {
        this.albumKind = key
        // if (key === ALBUM_KIND.VR) {
        //   // 购买了vr产品正常进tab 否则进入营销页
        //   if (this.vrPrivilege) {
        //     this.albumKind = key
        //   } else {
        //     hashHistory.push(VR_SELL_PATH)
        //   }
        // } else {
        //   this.albumKind = key
        // }
      }
    })
  }
}
